const getUsernameOrPreferredUsername = (caregiver: any) => {
  if (caregiver && caregiver.user.preferredUsername) return caregiver.user.preferredUsername;
  if (caregiver && caregiver.user.username) return caregiver.user.username;
  return 'Hospitalink';
};

export { getUsernameOrPreferredUsername };
